/**
 * @generated SignedSource<<ed584dfa443ae3786b24125d21cfa83c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type PortfolioProjectTextCoverStyle = "COLOR_BLACK" | "COLOR_BLUE" | "COLOR_GREEN" | "COLOR_ORANGE" | "COLOR_PURPLE" | "COLOR_SALMON" | "COLOR_WATERMELON" | "COLOR_WHITE" | "COLOR_YELLOW" | "SHAPE_COINS_DARK" | "SHAPE_COINS_LIGHT" | "SHAPE_COLLABORATION_DARK" | "SHAPE_COLLABORATION_LIGHT" | "SHAPE_FOCUS_DARK" | "SHAPE_FOCUS_LIGHT" | "SHAPE_GAIN_DARK" | "SHAPE_GAIN_LIGHT" | "SHAPE_STAIRS_DARK" | "SHAPE_STAIRS_LIGHT" | "SHAPE_WAVE_DARK" | "SHAPE_WAVE_LIGHT" | "SVG_BLUE" | "SVG_BLUE2" | "SVG_LINES_BLUE" | "SVG_LINES_GREEN" | "SVG_LINES_ORANGE" | "SVG_LINES_PURPLE" | "SVG_LINES_SALMON" | "SVG_LINES_YELLOW" | "SVG_WHITE" | "SVG_WHITE2" | "SVG_YELLOW" | "SVG_YELLOW2" | "VAPOR_GRADIENT_BLUE_DARK" | "VAPOR_GRADIENT_BLUE_LIGHT" | "VAPOR_GRADIENT_GREEN_DARK" | "VAPOR_GRADIENT_GREEN_LIGHT" | "VAPOR_GRADIENT_PURPLE_DARK" | "VAPOR_GRADIENT_PURPLE_LIGHT" | "VAPOR_GRADIENT_SALMON_DARK" | "VAPOR_GRADIENT_SALMON_LIGHT" | "VAPOR_GRADIENT_WATERMELON_DARK" | "VAPOR_GRADIENT_WATERMELON_LIGHT" | "VAPOR_GRADIENT_WHITE_DARK" | "VAPOR_GRADIENT_YELLOW_LIGHT" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type ProjectCardV2DataWrapper_portfolioProject$data = {
  readonly analyticsId: number;
  readonly cover: {
    readonly __typename: "PortfolioProjectImageCover";
    readonly image: {
      readonly animated: boolean;
      readonly uid: string;
    };
  } | {
    readonly __typename: "PortfolioProjectTextCover";
    readonly style: PortfolioProjectTextCoverStyle;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  };
  readonly description: string | null;
  readonly id: string;
  readonly llmSuggestionId: string | null;
  readonly publishedAt: ContraAPIScalars.DateTime | null;
  readonly roles: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly name: string;
      };
    }>;
  };
  readonly slug: string;
  readonly title: string;
  readonly tools: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly name: string;
      };
    }>;
  };
  readonly " $fragmentType": "ProjectCardV2DataWrapper_portfolioProject";
};
export type ProjectCardV2DataWrapper_portfolioProject$key = {
  readonly " $data"?: ProjectCardV2DataWrapper_portfolioProject$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectCardV2DataWrapper_portfolioProject">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v2 = [
  (v0/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProjectCardV2DataWrapper_portfolioProject",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "analyticsId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "llmSuggestionId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "publishedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "cover",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            (v1/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "ContraImage",
              "kind": "LinkedField",
              "name": "image",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "animated",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "uid",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "type": "PortfolioProjectImageCover",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v1/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "style",
              "storageKey": null
            }
          ],
          "type": "PortfolioProjectTextCover",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PortfolioProjectRoleConnection",
      "kind": "LinkedField",
      "name": "roles",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PortfolioProjectRoleEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Role",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": (v2/*: any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PortfolioProjectToolConnection",
      "kind": "LinkedField",
      "name": "tools",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PortfolioProjectToolEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Tool",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": (v2/*: any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "PortfolioProject",
  "abstractKey": null
};
})();

(node as any).hash = "97eeb3601de0c43d8380e30f4bc2a37d";

export default node;
